import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import Box from '@mui/joy/Box'
import CircularProgress from '@mui/joy/CircularProgress'
import Modal from '@mui/joy/Modal'
import ModalDialog from '@mui/joy/ModalDialog'
import Typography from '@mui/joy/Typography'
import type { ReactNode } from 'react'

function CheckoutCenteredStateWrapper({
    children,
    backgroundColor,
}: {
    children: ReactNode
    backgroundColor?: string
}) {
    return (
        <Box
            sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor,
                px: 2,
            }}
        >
            {children}
        </Box>
    )
}

export function CheckoutLoadingState() {
    return (
        <CheckoutCenteredStateWrapper>
            <CircularProgress />
        </CheckoutCenteredStateWrapper>
    )
}

export function CheckoutPaymentResolutionOverlay({
    checkingText,
}: {
    checkingText: string
}) {
    const titleId = 'checkout-payment-resolution-checking'

    return (
        <Modal
            open
            disableEscapeKeyDown
            sx={{ zIndex: 2000 }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.48)',
                    },
                },
            }}
        >
            <ModalDialog
                role="alertdialog"
                aria-labelledby={titleId}
                variant="plain"
                sx={{
                    width: 'calc(100% - 32px)',
                    maxWidth: 440,
                    borderRadius: '18px',
                    p: {
                        xs: 3,
                        sm: 4,
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    textAlign: 'center',
                    boxShadow: 'lg',
                }}
            >
                <CircularProgress />
                <Typography id={titleId} sx={{ color: '#484848' }}>
                    {checkingText}
                </Typography>
            </ModalDialog>
        </Modal>
    )
}

export function CheckoutMessageState({
    message,
    action,
}: {
    message: string
    action: ReactNode
}) {
    return (
        <CheckoutCenteredStateWrapper backgroundColor="#F7F7F7">
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 520,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    textAlign: 'center',
                    backgroundColor: 'white',
                    borderRadius: '18px',
                    p: 4,
                }}
            >
                <ErrorOutlineRoundedIcon sx={{ fontSize: 64 }} />
                <Typography sx={{ color: '#484848' }}>{message}</Typography>
                {action}
            </Box>
        </CheckoutCenteredStateWrapper>
    )
}

export function CheckoutBookedState({
    title,
    text,
    action,
}: {
    title: string
    text: string
    action: ReactNode
}) {
    return (
        <CheckoutCenteredStateWrapper backgroundColor="#F7F7F7">
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 520,
                    backgroundColor: 'white',
                    borderRadius: '18px',
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    textAlign: 'center',
                }}
            >
                <CheckCircleRoundedIcon color="success" sx={{ fontSize: 64 }} />
                <Typography level="h3">{title}</Typography>
                <Typography sx={{ color: '#484848' }}>{text}</Typography>
                {action}
            </Box>
        </CheckoutCenteredStateWrapper>
    )
}

export function CheckoutExpiredState({
    title,
    text,
    action,
}: {
    title: string
    text: string
    action: ReactNode
}) {
    return (
        <CheckoutCenteredStateWrapper backgroundColor="#F7F7F7">
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 520,
                    backgroundColor: 'white',
                    borderRadius: '18px',
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    textAlign: 'center',
                }}
            >
                <ErrorOutlineRoundedIcon sx={{ fontSize: 64 }} />
                <Typography level="h3">{title}</Typography>
                <Typography sx={{ color: '#484848' }}>{text}</Typography>
                {action}
            </Box>
        </CheckoutCenteredStateWrapper>
    )
}
